/* @ngInject */
function EditorController ($scope, $q, $stateParams, $cookies, $sce, $translate, ToastService, CONSTANTS, UdsModalService, DocumentsService, UploadService) {
  const getManageAssetsDialogController = () =>
    $q.when(import('../../../repository/dialogs/manage-assets/manage-assets-dialog.controller'))
  const getAttachInsideTheModuleModalController = () =>
    $q.when(import('../../../repository/directives/attach-inside-the-module-modal/attach-inside-the-module-modal.controller'))

  const allowedExtensions = ['png', 'jpeg', 'jpg']

  $scope.asset = {}

  const api = {
    _getUrl,
    _getAsset,
    _handleIframeMessage,
    _addRepositoryDialog,
    _addEditorImageToS3,
    _openSettings
  }

  this.getApi = () => api

  activate()

  function activate () {
    if ($stateParams.id) {
      api._getUrl()
    } else {
      ToastService.showErrorToast($translate.instant('documentAccessDenied'))
      window.history.back()
    }

    window.addEventListener('message', _handleIframeMessage)
  }

  $scope.$on('$destroy', () => {
    window.removeEventListener('message', _handleIframeMessage)
  })

  async function _getAsset () {
    await DocumentsService.getDocumentById($stateParams.id).then(asset => {
      $scope.asset = asset
    })
  }

  function _getUrl () {
    const jwtToken = $cookies.getAll().jwt
    const docId = $stateParams.id
    const goBackRoute = $stateParams.goBackRoute || 'home'

    const baseUrl = (CONSTANTS.URL_APP_V2 || '').replace(/\/$/, '')

    const queryParams = []

    if (jwtToken) {
      queryParams.push(`jwt=${encodeURIComponent(jwtToken)}`)
    }

    if ($stateParams.template) {
      queryParams.push(`template=${encodeURIComponent($stateParams.template)}`)
    }

    if ($stateParams.readOnly !== null && $stateParams.readOnly !== undefined) {
      queryParams.push(`readOnly=${encodeURIComponent($stateParams.readOnly)}`)
    }

    if (goBackRoute) {
      queryParams.push(`goBackRoute=${encodeURIComponent(goBackRoute)}`)
    }

    const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''

    $scope.url = $sce.trustAsResourceUrl(`${baseUrl}/editor/${docId}${queryString}`)
  }

  function _handleIframeMessage (event) {
    if (!isValidEventOrigin(event.origin)) {
      return
    }

    switch (event.data.type) {
      case 'open-settings-modal':
        api._openSettings()
        break
      case 'go-back':
        window.location.href = event.data.data || 'home'
        break
      case 'open-repository-dialog':
        api._addRepositoryDialog()
        break
      case 'add-editor-image-to-s3':
        api._addEditorImageToS3(event.data.data)
        break
    }
  }

  function _addEditorImageToS3 (files) {
    UploadService.generateThumbnailInBrowserAndUploadMultipleFiles(files).then(assets => {
      const assetsUrls = assets.map(asset => asset.src)
      DocumentsService.emitEventsToReact('add-editor-image-to-s3-success', assetsUrls)
    })
  }

  function isValidEventOrigin (origin) {
    const urlToSearch = window.devEnv ? 'localhost' : '.deskfy.io'
    const isValid = origin.includes(urlToSearch)
    return isValid
  }

  async function _openSettings () {
    await api._getAsset()
    getManageAssetsDialogController().then(({ ManageAssetsDialogController }) => {
      const manageAssetsDialog = UdsModalService.createModal({
        controller: ManageAssetsDialogController,
        modalName: 'manageAssetsDialog',
        data: {
          assets: [$scope.asset],
          tabToOpen: 'general'
        },
        onClose: updatedAsset => {
          if (!updatedAsset) {
            return
          }

          $scope.asset.name = updatedAsset?.name
        }
      })

      manageAssetsDialog.open()
    })
  }

  function _addRepositoryDialog () {
    getAttachInsideTheModuleModalController().then(({ AttachInsideTheModuleModalController }) => {
      const attachInsideTheModuleModal = UdsModalService.createModal({
        controller: AttachInsideTheModuleModalController,
        modalName: 'attachInsideTheModuleModal',
        data: {
          selectedTab: 'recents',
          avoidSuccessOnConfirm: true,
          allowedAssetExtensionsSelection: allowedExtensions
        },
        onClose: async (assetsToAttach) => {
          if (!assetsToAttach?.length) {
            return
          }
          assetsToAttach = assetsToAttach.map(asset => asset.src.thumbnail)

          DocumentsService.emitEventsToReact('add-images-to-editor', assetsToAttach)
        }
      })

      attachInsideTheModuleModal.open()
    })
  }
}

export { EditorController }
